import { Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';

const CustomButton = (props) => {
  const { tooltipText } = props || {};

  return tooltipText ? (
    <TooltipButton {...props} />
  ) : (
    <BasicButton {...props} />
  );
};

export default CustomButton;

const BasicButton = (props) => {
  const {
    label,
    type,
    variant,
    endIcon,
    startIcon,
    className,
    onClick,
    disabled,
    color,
    fullWidth,
    hidden,
    size = 'medium',
  } = props || {};

  return (
    <Button
      variant={variant || 'contained'}
      endIcon={endIcon || null}
      onClick={onClick}
      className={`${className} ${!label && 'mr-0-icon'}`}
      startIcon={startIcon}
      type={type || 'submit'}
      disabled={!!disabled}
      color={color || 'primary'}
      size={size}
      fullWidth={fullWidth}
      hidden={!!hidden}
    >
      {label}
    </Button>
  );
};

const TooltipButton = (props) => {
  const { tooltipText, tooltipPlacement, hidden } = props || {};

  return (
    <Tooltip
      title={tooltipText}
      placement={tooltipPlacement || 'top'}
      arrow={true}
      hidden={!!hidden}
    >
      <div>
        <BasicButton {...props} />
      </div>
    </Tooltip>
  );
};
